import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToastController, ModalController } from '@ionic/angular';
import { Webhook } from 'src/app/models/Webhook';
import { InstitutionService } from 'src/app/providers/institution-service/institution-service';
import { ProjectService } from 'src/app/providers/project-service/project-service';
import { TranslationBridge } from 'src/app/providers/translation-bridge/translation-bridge';
import { WebhookService } from 'src/app/providers/webhook-service/webhook-service';
import { WebhookExecutionsModalComponent } from '../webhook-executions-modal/webhook-executions-modal.component';

@Component({
  selector: 'webhook-list',
  templateUrl: './webhook-list.component.html',
  styleUrls: ['./webhook-list.component.scss'],
})
export class WebhookListComponent  implements OnInit {


  _webhooks: Webhook[] = [];
  @Input()
  set webhooks(webhooks: Webhook[]) {
    this._webhooks = webhooks;
  }
  get webhooks(): Webhook[] {
    return this._webhooks;
  }

  @Output() itemChanged = new EventEmitter<any>();
  @Output() itemSelected = new EventEmitter<Webhook>();

  menuPopoverIndex: number | null = null;
  menuPopoverEvent: any = null;

  constructor(public projectService: ProjectService, 
    private webhookService: WebhookService,
    public institutionService: InstitutionService,
    private toastController: ToastController,
    private modalController: ModalController,
    private translate: TranslationBridge) { }


    ngOnInit() {
    }

  

    webhookMessages(index: number){
      var messages = [];
      var key = this._webhooks[index];
      if(!key.active){
        messages.push({
          type: "warning",
          icon: "power",
          title: "Webhook is inactive",
          text: this.translate.get('WEBHOOK_OFFLINE_INFO'),
          actionTitle: "",
          action: null
        });
      }
      return messages;
    }
  
    public openWebhookDetail(index: number){
      this.itemSelected.emit(this._webhooks[index]);
    }

    public async openExecutionsModal(index: number){
      const webhook = this._webhooks[index];
      
      const modal = await this.modalController.create({
        component: WebhookExecutionsModalComponent,
        componentProps: {
          webhook: webhook
        },
        cssClass: 'huge-modal webhook-executions-modal'
      });
      
      return await modal.present();
    }

    openMenuPopover(event: Event, index: number) {
      event.stopPropagation();
      this.menuPopoverIndex = index;
      this.menuPopoverEvent = event;
    }

    closeMenuPopover() {
      this.menuPopoverIndex = null;
      this.menuPopoverEvent = null;
    }

}
